import { useMemo } from "react";
import { useLatest } from "../../../lib/hooks/useLatest.js";
import { TestPresetTag, testPreset } from "../../../testStreamPreset.js";
import { useStable } from "../../../lib/hooks/useStable.js";
function getSettings(streamConfig) {
  if (TestPresetTag in streamConfig) {
    return streamConfig;
  }
  const {
    serviceKey,
    playbackType,
    adsEnabled,
    assetMetadata: { channelId, channelName, programmeId, programmeTitle, duration, brand, type }
  } = streamConfig;
  const assetMetadata = { channelId, channelName, programmeId, programmeTitle, duration };
  if (brand) {
    assetMetadata.brand = brand;
  }
  if (type) {
    assetMetadata.type = type;
  }
  return { serviceKey, playbackType, assetMetadata, disableAds: adsEnabled === false };
}
function useGenerateSessionConfig({
  mParticleId,
  usPrivacy,
  gpp,
  gdpr,
  mvpdHash,
  autoplay,
  sessionKey,
  streamConfig,
  mutedAutoplay
}) {
  const streamSettings = useStable(getSettings(streamConfig));
  const latestInitData = useLatest({
    autoplay,
    mParticleId,
    usPrivacy,
    gpp,
    gdpr,
    mvpdHash,
    mutedAutoplay
  });
  return useMemo(() => {
    if (TestPresetTag in streamSettings) {
      return testPreset.streamConfig;
    }
    const initData = latestInitData.current;
    const config = {
      key: sessionKey,
      type: streamSettings.playbackType,
      vac: defineVac({ ...initData, duration: streamSettings.assetMetadata.duration }),
      reporting: {
        assetMetadata: streamSettings.assetMetadata,
        contentUrl: location.href
      },
      autoplay: initData.autoplay,
      muted: initData.mutedAutoplay,
      adInsertion: {
        disabled: streamSettings.disableAds
      }
    };
    Object.assign(config, {
      advertising: {
        contentId: streamSettings.serviceKey,
        adCompatibilityEncodingProfile: "am_abrspec"
      }
    });
    return config;
  }, [streamSettings, latestInitData, sessionKey]);
}
function defineVac({ mvpdHash, mParticleId, usPrivacy, gpp, gdpr, duration }) {
  const vac = {
    deviceAdvertisingTrackingConsent: false,
    coppaApplies: false,
    mvpdHash,
    mParticleId,
    usPrivacy,
    durationMs: duration * 1e3
  };
  if (gpp) {
    vac.gpp = gpp.gppString;
    vac.gppSid = gpp.applicableSections[0] ?? 0;
  }
  if (gdpr) {
    vac.gdprApplies = gdpr.gdprApplies;
    vac.gdprConsentString = gdpr.gdprConsentString;
  }
  return vac;
}
export {
  useGenerateSessionConfig };
//# sourceMappingURL=dist/components/CoreVideoPlayer/generateSessionConfig/useGenerateSessionConfig.js.map